import npmIcon from '../assets/ecosystem-icons/npm.svg';
import nugetIcon from '../assets/ecosystem-icons/nuget.svg';
import pypiIcon from '../assets/ecosystem-icons/pypi.svg';
import goIcon from '../assets/ecosystem-icons/go.svg';
import mavenIcon from '../assets/ecosystem-icons/maven.svg';
import rubygemsIcon from '../assets/ecosystem-icons/rubygems.svg';
import cratesIcon from '../assets/ecosystem-icons/crates.svg';

const iconMap: Record<string, string> = {
  npm: npmIcon,
  nuget: nugetIcon,
  NuGet: nugetIcon,
  pypi: pypiIcon,
  PyPI: pypiIcon,
  go: goIcon,
  Go: goIcon,
  maven: mavenIcon,
  Maven: mavenIcon,
  rubygems: rubygemsIcon,
  RubyGems: rubygemsIcon,
  'crates.io': cratesIcon,
  crates: cratesIcon,
};

interface EcosystemIconProps {
  ecosystem: string;
  size?: number;
  className?: string;
}

export function EcosystemIcon({ ecosystem, size = 20, className }: EcosystemIconProps) {
  const src = iconMap[ecosystem] ?? iconMap[ecosystem.toLowerCase()];

  if (!src) {
    return (
      <span
        className={`inline-flex items-center justify-center rounded bg-surface-raised text-[10px] font-bold text-text-secondary ${className ?? ''}`}
        style={{ width: size, height: size }}
      >
        {ecosystem.charAt(0).toUpperCase()}
      </span>
    );
  }

  return (
    <img
      src={src}
      alt={ecosystem}
      width={size}
      height={size}
      className={className}
    />
  );
}
